import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import ChartNoData from "components/charting/ChartNoData";
import Button from "components/Button";
import PlusIcon from "components/Icons/PlusIcon";
import useAddOneRepMaxDialog from "../../providers/AddOneRepMaxDialogProvider/useAddOneRepMaxDialog";

const ButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
});

function OneRepMaxChartNoDataManual() {
  const { t } = useTranslation();
  const { openAddOneRepMaxDialog, disabled } = useAddOneRepMaxDialog();

  return (
    <ChartNoData
      title={t("charting.one_rep_max_no_data_manual_title")}
      description={t("charting.one_rep_max_no_data_manual_description")}
    >
      <ButtonContainer>
        <Button
          size="small"
          startIcon={<PlusIcon />}
          variant="tertiary"
          onClick={openAddOneRepMaxDialog}
          disabled={disabled}
        >
          {t("charting.one_rep_max_no_data_manual_add_button")}
        </Button>
      </ButtonContainer>
    </ChartNoData>
  );
}

export default OneRepMaxChartNoDataManual;
